// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pgmdealers_container {
  width: 100%;
  display: flex;
}
.pgmdealers_container .sidebar {
  width: 20%;
  background: #dde7f5;
}
.pgmdealers_container .pgmlistmain {
  width: 80%;
  height: 100vh;
  background: #ffffff;
}
.pgmdealers_container .pgmdealers_text {
  display: flex;
  justify-content: space-between;
  width: 95%;
  margin: 1rem;
  padding: 1rem;
}
.pgmdealers_container .dealers_text {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  color: #10132e;
}
.pgmdealers_container .dealers_button {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  color: #ffffff;
  border: none;
  height: 2.5rem;
  cursor: pointer;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pgmdealers_container .input-wrapper {
  position: relative;
}
.pgmdealers_container input {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  width: 92%;
  height: 2.3rem;
  margin: 10px;
  line-height: 6ex;
}
.pgmdealers_container label {
  position: absolute;
  top: 0.2ex;
  z-index: 1;
  left: 2em;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
}
.pgmdealers_container .select-wrapper {
  position: relative;
  display: block;
}
.pgmdealers_container select {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  margin: 10px;
  line-height: 6ex;
  width: 94%;
  height: 2.5rem;
}
.pgmdealers_container .pgmlistdropdown_textfield {
  display: flex;
  justify-content: space-between;
  width: 95%;
  background: #ffffff;
  border: 1px solid #c1c6d0;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #c1c6d0;
  border-radius: 6px;
  margin: 1rem;
  padding: 0.6rem;
}
.pgmdealers_container .button_search {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  color: #ffffff;
  width: 40%;
  height: 2.5rem;
  text-align: center;
  justify-content: center;
  border: none;
  margin: 0.6rem 1rem;
}
.pgmdealers_container .button_div {
  display: flex;
  justify-content: center;
  align-items: center;
}
.pgmdealers_container .tabledata {
  display: flex;
  width: 96%;
  margin: 1rem;
}
.pgmdealers_container .table {
  border-collapse: collapse;
  width: 100%;
  background: #ffffff;
  border: 0.5px solid #999797;
}
.pgmdealers_container .tablesth {
  color: white;
  text-align: left;
  padding: 14px 12px;
  background-color: #f5f5f5;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  background: #0c3688;
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px -2px 0px 0px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
}
.pgmdealers_container .tabletd {
  text-align: left;
  padding: 22px 5px;
  font-style: normal;
  font-weight: 400;
  font-size: 16.4px;
  text-align: left;
  padding: 8px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #070707;
}
.pgmdealers_container .tabletd_view {
  text-align: left;
  padding: 22px 5px;
  text-align: left;
  padding: 8px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  text-decoration-line: underline;
  color: #0c3688;
}
.pgmdealers_container .footer_div {
  margin-top: 1rem;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}
.pgmdealers_container .header_border {
  background: #C0C8DA;
  height: 2.4rem;
  border: 1px solid #C0C8DA;
}
.pgmdealers_container .header_border > img {
  margin: 0.9rem 1rem;
}
.pgmdealers_container .header_border > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  letter-spacing: -0.28px;
  margin: 0.7rem 1rem;
}
.pgmdealers_container .pgmlistdropdown_div {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/PgmDealers/pgmdealers.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;AACJ;AACA;EACE,UAAA;EACA,mBAAA;AACF;AACA;EACE,UAAA;EACA,aAAA;EACA,mBAAA;AACF;AACA;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;AACF;AACA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AACF;AACA;EACE,mEAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACA;EACE,kBAAA;AACF;AAEA;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AAAF;AAGA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AADF;AAIA;EACE,kBAAA;EACA,cAAA;AAFF;AAKA;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;AAHF;AAKA;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAHF;AAKA;EACE,mEAAA;EACA,8CAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;AAHF;AAKA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAHF;AAKA;EACE,aAAA;EACA,UAAA;EACA,YAAA;AAHF;AAKA;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;AAHF;AAKA;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,8CAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAHF;AAKA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAHF;AAKA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;AAHF;AAKA;EACE,gBAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;AAHF;AAKA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAHF;AAKA;EACE,mBAAA;AAHF;AAKA;EAEA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAJA;AAMA;EACE,WAAA;AAJF","sourcesContent":[".pgmdealers_container {\n    width: 100%;\n    display: flex;\n\n.sidebar {\n  width: 20%;\n  background: #dde7f5;\n}\n.pgmlistmain {\n  width: 80%;\n  height: 100vh;\n  background: #ffffff;\n}\n.pgmdealers_text {\n  display: flex;\n  justify-content: space-between;\n  width: 95%;\n  margin: 1rem;\n  padding: 1rem;\n}\n.dealers_text {\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1.25rem;\n  color: #10132e;\n}\n.dealers_button {\n  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n  border-radius: 5px;\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 1rem;\n  color: #ffffff;\n  border: none;\n  height: 2.5rem;\n  cursor: pointer;\n  padding: 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.input-wrapper {\n  position: relative;\n}\n\ninput {\n  border: 1px solid gray;\n  border-radius: 6px;\n  position: relative;\n  width: 92%;\n  height: 2.3rem;\n  margin: 10px;\n  line-height: 6ex;\n}\n\nlabel {\n  position: absolute;\n  top: 0.2ex;\n  z-index: 1;\n  left: 2em;\n  background-color: white;\n  padding: 0 5px;\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  color: #0c3688;\n}\n\n.select-wrapper {\n  position: relative;\n  display: block;\n}\n\nselect {\n  border: 1px solid gray;\n  border-radius: 6px;\n  position: relative;\n  margin: 10px;\n  line-height: 6ex;\n  width: 94%;\n  height: 2.5rem;\n}\n.pgmlistdropdown_textfield {\n  display: flex;\n  justify-content: space-between;\n  width: 95%;\n  background: #ffffff;\n  border: 1px solid #c1c6d0;\n  border-radius: 6px;\n  background: #ffffff;\n  border: 1px solid #c1c6d0;\n  border-radius: 6px;\n  margin: 1rem;\n  padding: 0.6rem;\n}\n.button_search {\n  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n  border-radius: 5px;\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  color: #ffffff;\n  width: 40%;\n  height: 2.5rem;\n  text-align: center;\n  justify-content: center;\n  border: none;\n  margin: 0.6rem 1rem;\n}\n.button_div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.tabledata {\n  display: flex;\n  width: 96%;\n  margin: 1rem;\n}\n.table {\n  border-collapse: collapse;\n  width: 100%;\n  background: #ffffff;\n  border: 0.5px solid #999797;\n}\n.tablesth {\n  color: white;\n  text-align: left;\n  padding: 14px 12px;\n  background-color: #f5f5f5;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  background: #0c3688;\n  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n  border-radius: 5px -2px 0px 0px;\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  color: #ffffff;\n}\n.tabletd {\n  text-align: left;\n  padding: 22px 5px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16.4px;\n  text-align: left;\n  padding: 8px;\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  color: #070707;\n}\n.tabletd_view {\n  text-align: left;\n  padding: 22px 5px;\n  text-align: left;\n  padding: 8px;\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  text-decoration-line: underline;\n  color: #0c3688;\n}\n.footer_div {\n  margin-top: 1rem;\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n}\n.header_border {\n  background: #C0C8DA;\n  height: 2.4rem;\n  border: 1px solid #C0C8DA;\n}\n.header_border>img {\n  margin: 0.9rem 1rem;\n}\n.header_border > span{\n  \nfont-family: 'Nunito';\nfont-style: normal;\nfont-weight: 500;\nfont-size: 12px;\nline-height: 16px;\ndisplay: flex;\nalign-items: center;\nletter-spacing: -0.28px;\nmargin: 0.7rem 1rem;\n}\n.pgmlistdropdown_div {\n  width: 100%;\n}\n\n// @media screen and (max-width:780px) {\n//   .pgmlistmain {\n//     width: 100%;\n//     height: 100vh;\n//     background: #ffffff;\n//   }\n//   .pgmlist_container {\n//     width: 100%;\n//     display: flex;\n//     flex-direction: column;\n// }\n// }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
